import { render, staticRenderFns } from "./FundingScopesOrgaWaitingForReview.vue?vue&type=template&id=401e4eca&"
import script from "./FundingScopesOrgaWaitingForReview.vue?vue&type=script&lang=ts&"
export * from "./FundingScopesOrgaWaitingForReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports